/* eslint-disable consistent-return */
/* eslint-disable react/jsx-key */
import React from 'react';
import I18n from 'i18n-js';
import moment from 'moment';
import _get from 'lodash/get';
import { bool, string, func, arrayOf, shape } from 'prop-types';
import noImageSvg from 'public/images/no-image.png';
import vehiclePng from 'public/images/vehicle.png';
import classnames from 'classnames';
import { Form, Select, Icon, Row, Col } from 'grab-ui';
import { isEmpty } from 'common/utils/data-utils';
import {
  SERVICE_TYPE_SUB_INFO,
  SAME_DAY_NOT_AVAILABLE,
} from 'constants/booking-constants';
import Image from 'components/image/image';

import cssSelect from './select-field.less';
import cssForm from '../form-field.less';

const Option = Select.Option;
const FormItem = Form.Item;

const SelectField = ({
  id,
  label,
  required,
  validateMes,
  options,
  placeholder,
  initialValue,
  form,
  className,
  optionClassName,
  dropdownClassName,
  onSelect,
  disabled,
  showSelectedMarker,
  showingRequiredMark,
  showSearch,
  filterOption,
  quotes,
  serviceTypesMap,
  windowTime = {},
}) => {
  const renderCustomDropdown = () => {
    if (
      !isEmpty(quotes) &&
      quotes.deliveries.length > 0 &&
      !isEmpty(serviceTypesMap)
    ) {
      const deliveryQuotes = _get(quotes, 'deliveries[0].quotes') || [];
      const isQuoteErrors = deliveryQuotes.find(quote => quote.errors);

      if (isEmpty(isQuoteErrors)) return;
      const { serviceTypesIconBucket } = window.Grab.config;
      return (
        <div>
          <Row
            className={cssSelect.servicesUnableContainer}
            type="flex"
            align="middle"
          >
            <Col>
              <Icon theme="filled" type="exclamation-circle" />
            </Col>
            <Col>
              <p className={cssSelect.disableServiceText}>
                {I18n.t(SAME_DAY_NOT_AVAILABLE, {
                  from: moment(windowTime.from).format('HH:mm'),
                  to: moment(windowTime.to).format('HH:mm'),
                })}
              </p>
            </Col>
          </Row>
          {deliveryQuotes.map(quote => {
            const { serviceID, errors } = quote;
            if (isEmpty(errors)) return null;

            const iconName = _get(serviceTypesMap, `[${serviceID}].iconName`);
            const serviceName = _get(serviceTypesMap, `[${serviceID}].name`);
            const src = isEmpty(iconName)
              ? noImageSvg
              : `${serviceTypesIconBucket}/uploads/taxi_type/${serviceID}/icon/deprecated_${iconName}`;
            return (
              <div
                key={serviceID}
                aria-disabled
                className={cssSelect.serviceTypeOptionUnavailable}
              >
                <div className={cssSelect.leftPanel}>
                  <Image fallbackSrc={vehiclePng} src={src} alt="" />
                  <div>
                    <h5>{serviceName}</h5>
                    <h6>{I18n.t(SERVICE_TYPE_SUB_INFO)}</h6>
                  </div>
                </div>
                <div className={cssSelect.rightPanel}>
                  <h5>{errors.map(error => error.message)}</h5>
                </div>
              </div>
            );
          })}
        </div>
      );
    }
  };
  const { getFieldDecorator } = form;
  return (
    <FormItem
      label={label}
      className={classnames(cssForm.formItem, {
        [cssSelect.showingMarkField]: showingRequiredMark,
      })}
    >
      {getFieldDecorator(id, {
        rules: [
          {
            required,
            message: validateMes,
          },
        ],
        initialValue,
      })(
        <Select
          placeholder={placeholder}
          filterOption={filterOption || false}
          disabled={disabled}
          showSearch={showSearch}
          className={classnames(cssSelect.select, className)}
          dropdownClassName={classnames(cssSelect.dropdown, dropdownClassName, {
            [cssSelect.emptySelect]: isEmpty(options),
          })}
          onSelect={!onSelect ? () => {} : onSelect}
          dropdownRender={menu => (
            <div>
              {menu}
              {renderCustomDropdown()}
            </div>
          )}
        >
          {options.map(option => (
            <Option
              className={classnames(cssSelect.option, optionClassName)}
              key={option.value}
              title={option.title}
              disabled={option.disabled}
            >
              {option.child}
              {showSelectedMarker && (
                <Icon
                  type="check"
                  className={cssSelect.markIcon}
                  style={{ display: 'none' }}
                />
              )}
            </Option>
          ))}
        </Select>,
      )}
    </FormItem>
  );
};

SelectField.propTypes = {
  id: string.isRequired,
  label: string,
  required: bool,
  options: arrayOf(shape({})),
  form: shape({}).isRequired, // eslint-disable-line react/forbid-prop-types
  className: string, // eslint-disable-line react/forbid-prop-types
  optionClassName: string,
  dropdownClassName: string,
  placeholder: string, // eslint-disable-line react/forbid-prop-types
  validateMes: string, // eslint-disable-line react/forbid-prop-types
  initialValue: string, // eslint-disable-line react/forbid-prop-types
  disabled: bool,
  onSelect: func,
  showSelectedMarker: bool,
  showingRequiredMark: bool,
  showSearch: bool,
  filterOption: func,
  quotes: shape({}),
  serviceTypesMap: shape({}),
  windowTime: shape({}),
};

SelectField.defaultProps = {
  label: '',
  required: false,
  options: [],
  loading: false,
  className: null,
  optionClassName: null,
  dropdownClassName: null,
  placeholder: '',
  validateMes: '',
  initialValue: null,
  disabled: false,
  onSelect: null,
  showSelectedMarker: false,
  showingRequiredMark: false,
  defaultValue: '',
  showSearch: false,
  filterOption: () => {},
  quotes: {},
  serviceTypesMap: {},
  windowTime: {},
};

export default SelectField;
